/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventProcessValidateDto } from '../../models/workflow-trigger-event-process-validate-dto';
import { WorkflowTriggerEventProcessValidationResultDto } from '../../models/workflow-trigger-event-process-validation-result-dto';

export interface AutomatedProcessValidateTriggerEventProcess$Params {
      body: WorkflowTriggerEventProcessValidateDto
}

export function automatedProcessValidateTriggerEventProcess(http: HttpClient, rootUrl: string, params: AutomatedProcessValidateTriggerEventProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessValidationResultDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessValidateTriggerEventProcess.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowTriggerEventProcessValidationResultDto>;
    })
  );
}

automatedProcessValidateTriggerEventProcess.PATH = '/automated-process/workflow-trigger/trigger-event-process/validate';